import { createFileRoute } from '@tanstack/react-router'

import KepPage from '@/components/pages/backoffice/_klb-petani/_kep/containers/KepPage'

export const Route = createFileRoute('/_backoffice/klb-petani/kep/')({
  component: KepPage
})
